import React from "react";

import BankDeposit from "../assets/bank_deposit.svg";
import CashPickup from "../assets/cash_pickup.svg";
import MobileMoney from "../assets/mobile_money.svg";
import MobileTopup from "../assets/mobile-banking.svg";

const featureDetails = [
  {
    name: "Bank Deposit",
    img: BankDeposit,
    info: "Money goes directly to the receiver's account.",
  },
  {
    name: "Cash Pickup",
    img: CashPickup,
    info: "Cash is available at collection locations in minutes.",
  },
  {
    name: "Mobile Money",
    img: MobileMoney,
    info: "Money is added instantly to Mobile Money wallets.",
  },
  {
    name: "Mobile Top Up",
    img: MobileTopup,
    info: "Mobile Top Up is topped-up instantly.",
  },
];

function Features(props) {
  return (
    <div className="mt-5 bg-gray-200 rounded-15 pt-5 pb-5 px-2 mb-5">
      <h3 className="fs-1 text-center mb-3 mb-sm-0">
        Convenient ways to Send Money
      </h3>
      <div className="row">
        {featureDetails.map((ft) => (
          <div key={ft.name} className="col-sm-12 col-md-4 col-lg-3">
            <div className="max-width-260 mx-auto text-center pt-2 pb-2 pt-sm-5 pb-sm-5">
              <div className="box-size-78 mx-auto mb-3 text-danger">
                <img src={ft.img} alt={ft.name} className="img-fluid" />
              </div>
              <h4 className="fs-22 text-dark">{ft.name}</h4>
              <p className="fs-18">{ft.info}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

export default Features;
